//src/App.jsx
import React from 'react';
import Routes from './Routes';
import ThemeProvider from './components/ui/ThemeProvider';
import './styles/tailwind.css';


function App() {
  return (
    <ThemeProvider>
      <Routes />
    </ThemeProvider>
  );
}

export default App;